export function getFirstWord(text: string): string {
  return text.split(' ')[0] ?? ''
}

export function trimChar(word: string): string {
  return word.replace(/^[\s,.]+|[\s,.]+$/g, '')
}

export const sortArrayKeyByFirstWord = (array: any, key: string) => {
  if (!Array.isArray(array) || array.length === 0) {
    return []
  }

  return array?.sort((a: any, b: any) => {
    // Fallback to an empty string if the value is null or undefined
    const aValue = a[key] ?? ''
    const bValue = b[key] ?? ''

    const surnameA = trimChar(getFirstWord(aValue))
    const surnameB = trimChar(getFirstWord(bValue))

    return surnameA.localeCompare(surnameB)
  })
}

export function getLastWord(str: string | null | undefined): string {
  // Check if str is null or undefined, and return an empty string as a fallback
  if (str === null || str === undefined || str.trim() === '') {
    return ''
  }

  const words = str.split(' ')
  return words[words.length - 1]
}

export function getFirstLetter(str: string) {
  const letter = str.charAt(0) === '‘' ? str.charAt(1) : str.charAt(0)
  return letter
}
